import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { useTranslation } from "@coworker/locales";
import CustomPeriodCss from "./CustomPeriod.module.css";
import { SelectOption, SelectOptionPeriod } from "../../types/filter";
import { DatePicker } from "../../../components/DatePicker/DatePicker";

dayjs.extend(isSameOrBefore);

interface CustomPeriodProps {
  onChange: (option: SelectOption) => void;
  selected: SelectOptionPeriod;
}

export const CustomPeriod = ({ onChange, selected }: CustomPeriodProps) => {
  const today = dayjs().format("YYYY-MM-DD");
  const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");

  const { startDate, endDate } = selected;

  const { t } = useTranslation();

  const handleStartDateChange = (value: string | null) => {
    const valueString = value ?? "";
    const newStart = dayjs(valueString);
    const currentEnd = dayjs(endDate);

    if (!endDate || newStart.isBefore(currentEnd)) {
      onChange({ ...selected, startDate: valueString });
    }
  };

  const handleEndDateChange = (value: string | null) => {
    const valueString = value ?? "";
    const newEnd = dayjs(valueString);
    const currentStart = dayjs(startDate);

    if (
      (!startDate || newEnd.isAfter(currentStart)) &&
      newEnd.isSameOrBefore(dayjs())
    ) {
      onChange({ ...selected, endDate: valueString });
    }
  };

  return (
    <div className={CustomPeriodCss["custom-period"]}>
      <DatePicker
        label={t("startDateString")}
        value={startDate}
        onChange={handleStartDateChange}
        max={
          dayjs(endDate).isValid()
            ? dayjs(endDate).subtract(1, "day").format("YYYY-MM-DD")
            : yesterday
        }
      />
      <DatePicker
        label={t("endDateString")}
        value={endDate}
        onChange={handleEndDateChange}
        min={
          dayjs(startDate).isValid()
            ? dayjs(startDate).add(1, "day").format("YYYY-MM-DD")
            : ""
        }
        max={today}
      />
    </div>
  );
};
